import { IconBase } from './iconBase';

import { CustomIconsProp } from '../types';

export const Candidately = ({ size, color, className }: CustomIconsProp) => (
  <IconBase className={className} viewBox={30} size={size}>
    <g fill={color} transform="translate(0.5)">
      <path d="M0 15C0 23.2843 6.71573 30 15 30V0C6.71573 0 0 6.71573 0 15Z" />
      <circle cx="24.5" cy="25.5" r="4.5" />
    </g>
  </IconBase>
);
